import { render, staticRenderFns } from "./custom-header.vue?vue&type=template&id=4882b261&scoped=true"
import script from "./custom-header.vue?vue&type=script&lang=js"
export * from "./custom-header.vue?vue&type=script&lang=js"
import style0 from "./custom-header.vue?vue&type=style&index=0&id=4882b261&prod&scoped=true&lang=css"
import style1 from "./custom-header.vue?vue&type=style&index=1&id=4882b261&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4882b261",
  null
  
)

export default component.exports